<template>
  <v-layout>
    <v-flex>
      <v-card>
        <v-container v-if="isTSP">
          <v-row align="center">
            <v-col cols="3" md="3">
              <stat-card
                color="blue"
                icon="mdi-server"
                sub-icon="mdi-restart"
                :title="$t('sinceServerRestart').toUpperCase() + ':'"
              />
            </v-col>
            <v-col cols="5" md="3">
              <stat-card
                id="62168c00"
                color="green"
                icon="mdi-timer"
                sub-icon="mdi-check"
                :title="$t('successfulTimestamps').toUpperCase()"
                :value="tspRequestsSuccess"
              />
            </v-col>
            <v-col cols="5" md="3">
              <stat-card
                id="87ee81e6"
                color="red"
                icon="mdi-timer"
                sub-icon="mdi-monitor"
                :title="$t('rejectedTimestamps').toUpperCase()"
                :value="tspRequestsErrorClient"
              />
            </v-col>
            <v-col cols="5" md="3">
              <stat-card
                id="2f709011"
                color="red darken-4"
                icon="mdi-timer"
                sub-icon="mdi-server"
                :title="$t('timestampingErrors').toUpperCase()"
                :value="tspRequestsErrorServer"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-card raised>
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title class="subheading font-weight-medium text-left">
                      <v-avatar tile>
                        <v-img :src="require('../images/certificate-icon.png')"></v-img>
                      </v-avatar>
                      {{ $t('expiringCertificates', { signerType: $t('feature.TSP') }) }}
                    </v-list-item-title>
                    <expand-data-table
                      id="d1d802d6"
                      :headers="certificateTableHeaders"
                      :items="expiringTsResponderCertificates"
                      :issuer-trim="100"
                    />
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        <v-container v-if="isDSS || isMOBILSIGN">
          <v-row align="center">
            <v-col cols="3" md="3">
              <stat-card
                color="blue"
                icon="mdi-server"
                sub-icon="mdi-restart"
                :title="$t('sinceServerRestart').toUpperCase() + ':'"
              />
            </v-col>
            <v-col>
              <v-row>
                <v-col cols="9" md="6">
                  <stat-card
                    id="89a03817"
                    color="green"
                    icon="mdi-timer"
                    sub-icon="mdi-check"
                    :title="$t('successfulSignatures').toUpperCase()"
                    :value="dssRequestsSuccess"
                  />
                </v-col>
                <v-col cols="9" md="6">
                  <stat-card
                    id="fee68750"
                    color="red darken-4"
                    icon="mdi-timer"
                    sub-icon="mdi-server"
                    :title="$t('signingErrors').toUpperCase()"
                    :value="dssRequestsError"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-card raised>
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title class="subheading font-weight-medium text-left">
                      <v-avatar tile>
                        <v-img :src="require('../images/certificate-icon.png')"></v-img>
                      </v-avatar>
                      {{ $t('expiringCertificates', { signerType: $t('feature.DSS') }) }}
                    </v-list-item-title>
                    <expand-data-table
                      id="6136e3f8"
                      :headers="certificateTableHeaders"
                      :items="expiringDocSignerCertificates"
                      :issuer-trim="100"
                    />
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        <v-container v-if="isOCSP">
          <v-row align="center">
            <v-col cols="3" md="3">
              <stat-card
                color="blue"
                icon="mdi-server"
                sub-icon="mdi-restart"
                :title="$t('sinceServerRestart').toUpperCase() + ':'"
              />
            </v-col>
            <v-col cols="5" md="3">
              <stat-card
                id="b9386740"
                color="green"
                icon="mdi-timer"
                sub-icon="mdi-check"
                :title="$t('successfulOcsps').toUpperCase()"
                :value="ocspRequestsSuccess"
              />
            </v-col>
            <v-col cols="5" md="3">
              <stat-card
                id="dba5dfa8"
                color="red"
                icon="mdi-timer"
                sub-icon="mdi-monitor"
                :title="$t('rejectedOcsps').toUpperCase()"
                :value="ocspRequestsErrorClient"
              />
            </v-col>
            <v-col cols="5" md="3">
              <stat-card
                id="4104e7ea"
                color="red darken-4"
                icon="mdi-timer"
                sub-icon="mdi-server"
                :title="$t('ocspResponderingErrors').toUpperCase()"
                :value="ocspRequestsErrorServer"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-card raised>
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title class="subheading font-weight-medium text-left">
                      <v-avatar tile>
                        <v-img :src="require('../images/certificate-icon.png')"></v-img>
                      </v-avatar>
                      {{ $t('expiringCertificates', { signerType: $t('feature.OCSP') }) }}
                    </v-list-item-title>
                    <expand-data-table
                      id="c7622128"
                      :headers="certificateTableHeaders"
                      :items="expiringOcspResponderCertificates"
                      :issuer-trim="100"
                    />
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        <v-container>
          <v-row>
            <v-col v-if="isTSP && ntpMaxErrorLimit" cols="6" md="4">
              <v-card :class="ntpOk ? 'light-blue' : 'red'" raised>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="subheading font-weight-medium text-left white--text mb-2">
                      <v-avatar tile>
                        <v-img :src="require('../images/ntp-server-icon.png')"></v-img>
                      </v-avatar>
                      {{ $t('ntpStatus') }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="subtitle-1 text-left white--text">
                      {{ $t('leapIndicator') }}: {{ ntpLeapIndicator ? ntpLeapIndicator : 'n/a' }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle v-if="ntpLeapsec" class="subtitle-1 text-left white--text">
                      {{ $t('leapSec') }}: {{ ntpLeapsec }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle v-if="ntpLeapSecExpire" class="subtitle-1 text-left white--text">
                      {{ $t('leapSecExpire') }}: {{ ntpLeapSecExpire }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="subtitle-1 text-left white--text">
                      {{ $t('maxError') }}: {{ ntpMaxError ? ntpMaxError + ' ms' : 'n/a' }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="subtitle-1 text-left white--text">
                      {{ $t('maxErrorLimit') }}: {{ ntpMaxErrorLimit }} ms
                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="subtitle-1 text-left white--text">
                      {{ $t('lastMaxErrorExceeded') }}: {{ ntpLastMaxErrorExceeded ? ntpLastMaxErrorExceeded : $t('lastMaxErrorExceededNever') }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>
            <v-col>
              <v-card raised>
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title class="subheading font-weight-medium text-left">
                      <v-avatar tile>
                        <v-img :src="require('../images/ssl-certificate-icon.png')"></v-img>
                      </v-avatar>
                      {{ $t('expiringSslCertificates') }}
                    </v-list-item-title>
                    <expand-data-table
                      id="ff94eb9d"
                      :headers="certificateTableHeaders"
                      :items="expiringSsl"
                      :issuer-trim="50"
                      :serial-number-trim="isDSS || isMOBILSIGN ? 100 : 32"
                    />
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import server from '../api/server'
import Feature from '../Feature'
import StatCard from '../components/StatCard.vue'
import ExpandableDataTable from '../components/ExpandableDataTable.vue'
import { mapGetters } from 'vuex'
import { showToastError } from '../event-bus'

export default {
  name: 'Dashboard',

  components: {
    'stat-card': StatCard,
    'expand-data-table': ExpandableDataTable
  },

  data() {
    return {
      ntpLeapIndicator: null,
      ntpLeapsec: null,
      ntpLeapSecExpire: null,
      ntpMaxError: null,
      ntpMaxErrorLimit: null,
      ntpMaxErrorOverflow: false,
      ntpLastMaxErrorExceeded: null,
      tspRequestsSuccess: null,
      tspRequestsErrorClient: null,
      tspRequestsErrorServer: null,
      dssRequestsSuccess: null,
      dssRequestsError: null,
      ocspRequestsSuccess: null,
      ocspRequestsErrorClient: null,
      ocspRequestsErrorServer: null,
      expiringCertificates: [],
      expiringTsResponderCertificates: [],
      expiringDocSignerCertificates: [],
      expiringOcspResponderCertificates: [],
      expiringSsl: [],
      certificateTableHeaders: [
        {
          text: this.$t('serialNumber'),
          value: 'serialNumber',
          sortable: false
        },
        {
          text: this.$t('issuer'),
          align: 'left',
          value: 'issuer',
          sortable: false
        },
        {
          text: this.$t('notAfter'),
          value: 'notAfter',
          sortable: false
        }
      ],
      timer: null
    }
  },

  computed: {
    ...mapGetters(['hasFeatures']),
    isTSP() {
      return this.hasFeatures(Feature.TSP)
    },
    isDSS() {
      return this.hasFeatures(Feature.DSS)
    },
    isOCSP() {
      return this.hasFeatures(Feature.OCSP)
    },
    isMOBILSIGN() {
      return this.hasFeatures(Feature.MOBILSIGN)
    },
    ntpOk() {
      if (!this.ntpMaxErrorLimit) {
        return true
      }
      return this.ntpLeapIndicator && this.ntpLeapIndicator !== 'ALARM' && this.ntpMaxError <= this.ntpMaxErrorLimit
    }
  },

  mounted() {
    this.getMetrics()
    this.timer = setInterval(() => this.$store.state.currentUser.idToken ? this.getMetrics() : null, 5000)
  },

  beforeDestroy() {
    clearInterval(this.timer)
  },

  methods: {
    async getMetrics() {
      try {
        let metrics = await server.getMetrics()

        this.ntp(metrics)
        this.tspRequests(metrics)
        this.dssRequests(metrics)
        this.ocspRequests(metrics)
        this.expiringCertificatesSelection(metrics)
        this.expiringSslSelection(metrics)
      } catch (error) {
        showToastError(this.$t('toastMessage.errorWhileRetrievingData'))
      }
    },

    ntp(metrics) {
      this.ntpLeapIndicator = metrics.gauges['ntp.leapIndicator'] && metrics.gauges['ntp.leapIndicator'].value
      this.ntpLeapsec = metrics.gauges['ntp.leapSec'] && metrics.gauges['ntp.leapSec'].value
      this.ntpLeapSecExpire = metrics.gauges['ntp.leapSecExpire'] && metrics.gauges['ntp.leapSecExpire'].value
      this.ntpMaxErrorLimit = metrics.gauges['ntp.maxErrorLimit'] && metrics.gauges['ntp.maxErrorLimit'].value
      this.ntpMaxError = metrics.gauges['ntp.maxError'] && metrics.gauges['ntp.maxError'].value
      this.ntpLastMaxErrorExceeded = metrics.gauges['ntp.lastMaxErrorExceeded'] && metrics.gauges['ntp.lastMaxErrorExceeded'].value
    },

    tspRequests(metrics) {
      this.tspRequestsSuccess = metrics.counters['tsp.requests.success'] === undefined ? 0 : metrics.counters['tsp.requests.success'].count
      this.tspRequestsErrorClient = metrics.counters['tsp.requests.error.client'] === undefined ? 0 : metrics.counters['tsp.requests.error.client'].count
      this.tspRequestsErrorServer = metrics.counters['tsp.requests.error.server'] === undefined ? 0 : metrics.counters['tsp.requests.error.server'].count
    },

    dssRequests(metrics) {
      this.dssRequestsSuccess = metrics.counters['dss.requests.success'] === undefined ? 0 : metrics.counters['dss.requests.success'].count
      this.dssRequestsError = metrics.counters['dss.requests.error'] === undefined ? 0 : metrics.counters['dss.requests.error'].count
    },

    ocspRequests(metrics) {
      this.ocspRequestsSuccess = metrics.counters['ocsp.requests.success'] === undefined ? 0 : metrics.counters['ocsp.requests.success'].count
      this.ocspRequestsErrorClient = metrics.counters['ocsp.requests.error.client'] === undefined ? 0 : metrics.counters['ocsp.requests.error.client'].count
      this.ocspRequestsErrorServer = metrics.counters['ocsp.requests.error.server'] === undefined ? 0 : metrics.counters['ocsp.requests.error.server'].count
    },

    expiringCertificatesSelection(metrics) {
      this.expiringCertificates = metrics.gauges['certificate.expires'] && metrics.gauges['certificate.expires'].value
      let tssCerts = []
      let sfsCerts = []
      let ocspCerts = []
      this.expiringCertificates.forEach(certificate => {
        if (certificate.signerType === 'TS_RESPONDER') {
          tssCerts.push(certificate)
        } else if (certificate.signerType === 'DOC_SIGNER') {
          sfsCerts.push(certificate)
        } else if (certificate.signerType === 'OCSP_RESPONDER') {
          ocspCerts.push(certificate)
        }
      })
      this.expiringTsResponderCertificates = Object.assign([], this.expiringTsResponderCertificates, tssCerts)
      this.expiringDocSignerCertificates = Object.assign([], this.expiringDocSignerCertificates, sfsCerts)
      this.expiringOcspResponderCertificates = Object.assign([], this.expiringOcspResponderCertificates, ocspCerts)
    },

    expiringSslSelection(metrics) {
      if (metrics.gauges['ssl.expires'] && metrics.gauges['ssl.expires'].value) {
        this.expiringSsl = Object.assign([], this.expiringSsl, [ metrics.gauges['ssl.expires'].value ])
      }
    }
  }
}
</script>
